"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Amex_1 = __importDefault(require("@kawaui/icons/build/icons/payment/Amex"));
const ApplePay_1 = __importDefault(require("@kawaui/icons/build/icons/payment/ApplePay"));
const Bancontact_1 = __importDefault(require("@kawaui/icons/build/icons/payment/Bancontact"));
const Bizum_1 = __importDefault(require("@kawaui/icons/build/icons/payment/Bizum"));
const ConfianzaOnline_1 = __importDefault(require("@kawaui/icons/build/icons/payment/ConfianzaOnline"));
const CreditCard_1 = __importDefault(require("@kawaui/icons/build/icons/payment/CreditCard"));
const Floa_1 = __importDefault(require("@kawaui/icons/build/icons/payment/Floa"));
const Ideal_1 = __importDefault(require("@kawaui/icons/build/icons/payment/Ideal"));
const Illicado_1 = __importDefault(require("@kawaui/icons/build/icons/payment/Illicado"));
const Klarna_1 = __importDefault(require("@kawaui/icons/build/icons/payment/Klarna"));
const Maestro_1 = __importDefault(require("@kawaui/icons/build/icons/payment/Maestro"));
const MasterCard_1 = __importDefault(require("@kawaui/icons/build/icons/payment/MasterCard"));
const Oney_1 = __importDefault(require("@kawaui/icons/build/icons/payment/Oney"));
const PagoSeguro_1 = __importDefault(require("@kawaui/icons/build/icons/payment/PagoSeguro"));
const Paylib_1 = __importDefault(require("@kawaui/icons/build/icons/payment/Paylib"));
const Paypal_1 = __importDefault(require("@kawaui/icons/build/icons/payment/Paypal"));
const Verisign_1 = __importDefault(require("@kawaui/icons/build/icons/payment/Verisign"));
const Visa_1 = __importDefault(require("@kawaui/icons/build/icons/payment/Visa"));
const react_1 = require("react");
exports.PaymentIcon = (0, react_1.memo)(function PaymentIcon({ name, label }) {
    const iconSize = '50';
    const iconMap = {
        credit_card: CreditCard_1.default,
        visa: Visa_1.default,
        pay: Oney_1.default,
        amex: Amex_1.default,
        paylib: Paylib_1.default,
        mastercard: MasterCard_1.default,
        paypal: Paypal_1.default,
        illicado: Illicado_1.default,
        confianza: ConfianzaOnline_1.default,
        verisign: Verisign_1.default,
        pagoseguro: PagoSeguro_1.default,
        bancontact: Bancontact_1.default,
        ideal: Ideal_1.default,
        maestro: Maestro_1.default,
        klarna: Klarna_1.default,
        applepay: ApplePay_1.default,
        floa: Floa_1.default,
        bizum: Bizum_1.default,
    };
    const IconComponent = iconMap[name.toLowerCase()];
    if (!IconComponent)
        return null;
    return (0, jsx_runtime_1.jsx)(IconComponent, { role: "img", "aria-label": label, height: iconSize, width: iconSize });
});
exports.default = exports.PaymentIcon;
